<template>
    <div class="footer_page">
        <!--上 start-->
        <div class="footer_top">
            <div class="english">CONTACT US</div>
            <div class="ly_flex ly_flex_just_between">
                <!-- 电话 地址 邮箱 网址 start -->
                <div class="company_information ly_flex ly_flex_col ly_flex_just_around">
                    <p>029-85798677</p>
                    <!-- <p>邮箱：shduhfashduaiuh@qq.com</p> -->
                    <p>地 址：西安市高新区国家数字出版基地B座4层402室</p>
                    <p>网址：www.sxwisdom.cn</p>
                </div>
                <!-- 电话 地址 邮箱 网址 end -->

                <!-- 两个二维码 start -->
                <div class="ly_flex">
                    <div class="qr_code ly_flex ly_flex_col ly_flex_ali_center">
                        <img src="../../../assets/img/app.jpg" alt="">
                        <span>智徽健康APP</span>
                    </div>
                    <div class="qr_code ly_flex ly_flex_col ly_flex_ali_center">
                        <img src="../../../assets/img/gzh.jpg" alt="">
                        <span>公众号</span>
                    </div>

                </div>
                <!-- 两个二维码 end -->
            </div>
        </div>
        <!--上 end-->

        <!--下 start-->
        <div class="footer_bottom">
          @2007-2020 西安智徽信息工程有限公司版权所有
          <span class="handednessStyle" @click="goToUrl">陕ICP备18013435号</span>
        </div>
        <!--下 end-->
    </div>
</template>

<script>
    export default {
      name: "footerPage",
      methods:{
        goToUrl(){
          window.open(`https://beian.miit.gov.cn`, '_blank');
        }
      }
    }
</script>

<style lang="scss" scoped>
    .footer_page {
        width: 100%;
        height: 500px;
        background: #232733;
        /*上面*/
        .footer_top {
            margin:0 auto;
            padding-top:120px;
            width: 1200px;
            height: 310px;
            .english {
                margin-bottom: 30px;
                width: 100%;
                height: 68px;
                line-height: 68px;
                border-bottom: 1px solid #313542;
                font-size: 22px;
                color: #FFFFFF;
            }

            .company_information {
                height: 134px;

                p:first-child {
                    color: #FFFFFF;
                    font-size: 20px;
                }

                p {
                    color: #ECECEC;
                    font-size: 12px;
                }
            }

            /*二维码*/
            .qr_code {
                width: 132px;

                img {
                    margin-bottom: 15px;
                    width: 132px;
                    height: 132px;
                }

                span {
                    color: #ffffff;
                    font-size: 14px;
                }
            }

            .qr_code:first-child {
                margin-right: 60px;
            }
        }

        /*下面*/
        .footer_bottom{
            width: 100%;
            height: 69px;
            line-height: 70px;
            text-align: center;
            border-top:1px solid #313542;
            font-size: 12px;
            color: #FFFFFF;
        }
    }
</style>
